var br = {};

br.cpf = require('./document/cpf')
br.cnpj = require('./document/cnpj')
br.rg = require('./document/rg')
br.credit_card = require('./credit_card.js')

module.exports = br;

